import styles from './Logo.module.css';

interface Props {
  /** Wordmark font-size in px. The mascot icon and spacing scale with it. */
  size?: number;
  className?: string;
}

/** Aiphra logo — mascot icon + wordmark. */
export default function Logo({ size = 22, className }: Props) {
  const iconSize = size * 1.5;
  return (
    <span className={[styles.logo, className].filter(Boolean).join(' ')} style={{ fontSize: size }}>
      <img
        src="/logo-mascot.png"
        alt=""
        className={styles.mascot}
        width={iconSize}
        height={iconSize}
        style={{ width: iconSize, height: iconSize }}
      />
      Aiphra
    </span>
  );
}
